import React from 'react'
import AddressesDelete from "./AddressesDelete";
import AddressesEdit from "./AddressesEdit";


const AddressesActions = ({record, updater}) => {

    return(
        <React.Fragment>
            <AddressesEdit record={record} updater={updater}/>
            <AddressesDelete id={record.key} updater={updater} />
        </React.Fragment>
    )
}
export default AddressesActions